import React from 'react'
import PropTypes from 'prop-types'
import { withTranslation } from 'react-i18next'

import Zoom from 'app/components/SVGS/Zoom'

import './styles.scss'

const baseClass = 'search'

const Search = ({ t, value, placeHolder = '', className = '', onChange }) => {
  return (
    <div className={`${baseClass} ${className}`}>
      <input
        type="search"
        className={`${baseClass}__input`}
        placeholder={t(placeHolder)}
        value={value}
        onChange={onChange}
      />
      <div className={`${baseClass}__zoom`}>
        <Zoom />
      </div>
    </div>
  )
}

Search.propTypes = {
  value: PropTypes.string.isRequired,
  onChange: PropTypes.func.isRequired,
  placeHolder: PropTypes.string,
  className: PropTypes.string,
}

export default withTranslation()(Search)
